import * as React from 'react';
import { DHDistribution } from '~features/diamondHands/useDHDistribution';
import { fDate } from '~features/diamondHands/utils';

export function DHDistributionTimeline({
  distribution,
}: {
  distribution: DHDistribution;
}) {
  if (!distribution.start)
    return (
      <div>
        <p>Schedule to be announced</p>
      </div>
    );

  // <b>{fDate(distribution.start)}</b> –{' '}
  // <b>{fDate(distribution.end)}</b>
  return (
    <div>
      <p>
        Registration: <b>{fDate(distribution.registrationStart)}</b> –{' '}
        <b>{fDate(distribution.start)}</b>
      </p>
      <p>Airdrop: May 25, 18:00 UTC</p>
    </div>
  );
}
